// Principais
import { Component, OnInit, inject, ViewChild, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { FormArray } from '@angular/forms';
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgSelectConfig } from '@ng-select/ng-select';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subject, lastValueFrom } from "rxjs";
import { ADTSettings } from "angular-datatables/src/models/settings";
import { DataTableDirective } from "angular-datatables";

// Services
import { AuthService } from 'src/app/shared/auth/services/auth.service';
import { ConvivaErrorHandlingService } from 'src/app/shared/services/convivaErrorHandlingService';
import { EscolaService } from 'src/app/shared/services/escola.service';
import { PlanoContingenciaService } from 'src/app/shared/services/plano-contingencia.service';
import { ParametroPeriodoService } from 'src/app/shared/services/parametro-periodo.service';
import { ArquivoService } from 'src/app/shared/services/arquivo.service';

// Models
import { Diretoria } from 'src/app/shared/models/diretoria/Diretoria';
import { Escola } from 'src/app/shared/models/escola/Escola';
import { DefaultResponse } from 'src/app/shared/models/DefaultResponse';
import { UserLoginSed, AtribuicaoLoginSed } from 'src/app/shared/models/sed/UserLogin';
import { LogPlanoContingencia, PlanoContingencia } from 'src/app/shared/models/plano-contingencia/plano-contingencia';
import { Risco } from 'src/app/shared/models/plano-contingencia/risco';
import { PlanoStatus } from 'src/app/shared/enums/PlanoContingencia/PlanoStatus';
import { ArquivoAzure } from 'src/app/shared/models/arquivo/ArquivoAzure';

// Components
import { CardArquivoAnexadoComponent } from 'components/card-arquivo-anexado/card-arquivo-anexado.component';
import { VisualizarArquivoComponent } from 'components/visualizar-arquivo/visualizar-arquivo.component';

// Imports globais
import { angularCommonImports } from 'src/app/shared/ui/angular-common';
import { convivaCommonImports } from 'src/app/shared/ui/conviva-common';
import { libsCommonImports } from 'src/app/shared/ui/libs-common';

@Component({
  selector: 'app-plano-contingencia-cadastro',
  templateUrl: './plano-contingencia-cadastro.component.html',
  styleUrls: ['./plano-contingencia-cadastro.component.scss'],
  standalone: true,
  imports: [angularCommonImports, libsCommonImports, convivaCommonImports, CardArquivoAnexadoComponent, VisualizarArquivoComponent]
})
export class PlanoContingenciaCadastroComponent implements OnInit, OnChanges {

  // Injeções
  private escolaService = inject(EscolaService);
  private authService = inject(AuthService);
  private config = inject(NgSelectConfig);
  private spinnerService = inject(NgxSpinnerService);
  private toastr = inject(ToastrService);
  private ConvivaErrors = inject(ConvivaErrorHandlingService);
  private planoContingenciaService = inject(PlanoContingenciaService);
  private ParametroPeriodoService = inject(ParametroPeriodoService);
  private arquivoService = inject(ArquivoService);
  private route = inject(ActivatedRoute);
  private router = inject(Router);

  @Input() planoContingencia: PlanoContingencia | null = null;
  @Input() ehModal = false;
  @Input() ehEdicao = false;
  @Input() ehReadOnly = false;
  @Input() tituloAcaoModal: string = '';
  @Input() statusPlano: any = null;
  /** Cenário 2: status Aprovado – permitir apenas inclusão de anexos e riscos (demais campos somente leitura). */
  @Input() somenteAnexosERiscos = false;
  @Output() fechar = new EventEmitter<void>();

  /** Justificativa da reprovação (Devolvido para ajustes). Lê da API em camelCase ou PascalCase. */
  public get justificativaReprovacao(): string {
    const p = this.planoContingencia;
    if (!p) return '';
    const anyP = p as any;
    return anyP?.justificativa ?? anyP?.Justificativa ?? anyP?.dsJustificativa ?? anyP?.DS_JUSTIFICATIVA ?? '';
  }

  public dtOptions: any = {};
  public dtTrigger: Subject<ADTSettings> = new Subject<ADTSettings>();
  @ViewChild(DataTableDirective, { static: false })
  public dtElement: DataTableDirective;
  public isDtInitialized: boolean = false;
  private planoService = inject(PlanoContingenciaService);
  public showPesquisa: boolean = false;
  public PlanoStatus = PlanoStatus;

  public lstPlanos: PlanoContingencia[] = [];

  public showModalVisualizar = false;
  /** Modal "Histórico de atualizações" (aberto a partir do modal Visualizar plano / Editar no cadastro). */
  public showModalHistorico = false;
  public planoSelecionado: PlanoContingencia | null = null;
  public riscosSelecionados: Risco[] = [];
  public justificativa: string | null = null;
  public qtdeCaracteres: number = 0;
  public riscoAberto: number | null = null;
  //public showModalConfirmacao = false;
  public showModalEliminar = false;
  public showModalEditar = false;
  public showModalEnviarValidacao = false;
  /** Cenário 2: ao abrir edição pelo grid, true se plano Aprovado (apenas anexos e riscos). */
  public somenteAnexosERiscosModal = false;
  public showModalRemoverRisco = false;
  //public acaoModal: 'aprovar' | 'reprovar' | null = null;
  public codigoPlanoSelecionado: number | null = null;
  public anoModal = "";
  public escolaModal = "";
  public descricaoModal = "";
  public nomeRiscoModal = "";
  public indexRiscoRemover: number | null = null;

  // User
  public userLogado: UserLoginSed | null;
  public atribuicoesLogin!: AtribuicaoLoginSed;

  // Listas
  public diretorias: Diretoria[] = [];
  public escolas: Escola[] = [];

  // Legenda do grid
  public legendaGrid = `
    <span><i class="fa-solid fa-eye" style="color: #107BA7;"></i>Visualizar</span>
    <span><i class="fa-solid fa-pen-to-square" style="color: #107BA7;"></i>Editar</span>
    <span><i class="fa-solid fa-arrows-rotate" style="color: #107BA7;"></i>Enviar para Validação</span>
    <span><i class="fa-solid fa-trash" style="color: #dc3545;"></i>Excluir</span>
  `;

  // Formulário
  public formCadastrar!: FormGroup;
  public formEditar!: FormGroup;
  public submitted = false;
  public submittedEditar = false;

  // Riscos
  public riscos: Risco[] = [];
  public qtdeCaracteresComite: number = 0;
  public qtdeCaracteresComiteEditar: number = 0;

  // Opções dos combos
  public opcoesPerigo = [
    'Perigos naturais (fenômenos da natureza que podem gerar situações de emergência)',
    'Perigos ambientais / territoriais (condições do território onde a escola está inserida que ampliam a possibilidade de ocorrência do evento)',
    'Perigos estruturais (situações relacionadas à infraestrutura física da escola que podem gerar acidentes ou emergências)',
    'Perigos tecnológicos (eventos decorrentes de falhas em sistemas, equipamentos ou energia)',
    'Perigos químicos (situações envolvendo substâncias que podem causar acidentes)',
    'Perigos humanos (ações humanas, intencionais ou não, que aumentam o risco de acidentes)',
    'Outros perigos'
  ];

  public opcoesVulnerabilidade = [
    'Vulnerabilidade estrutural (fragilidades físicas do prédio ou da infraestrutura)',
    'Vulnerabilidade humana (fragilidades relacionadas às pessoas e ao preparo da comunidade escolar)',
    'Vulnerabilidade social (fragilidades relacionadas ao contexto social do entorno da escola)',
    'Vulnerabilidade ambiental / territorial (fragilidades relacionadas às características naturais e geográficas do entorno da escola)',
    'Vulnerabilidade tecnológica / de sistemas (fragilidades em sistemas essenciais de funcionamento e alerta)',
    'Vulnerabilidade Institucional / de Gestão (fragilidades administrativas e institucionais da escola)',
    'Outras vulnerabilidades'
  ];

  public opcoesDano = [
    'Danos físicos (impactos sobre a integridade física das pessoas)',
    'Danos materiais (impactos sobre o patrimônio e à infraestrutura da escola)',
    'Dano psicológicos / emocionais (impactos emocionais na comunidade escolar)',
    'Danos pedagógicos (impactos no funcionamento da escola e no processo educativo)',
    'Danos sociais / comunitários (impactos na relação da escola com a comunidade)',
    'Outros danos'
  ];

  public opcoesGrauRisco = [
    'Alto (evento provável ou recorrente / danos graves / evacuação total / risco à vida)',
    'Médio (evento possível de ocorrer / danos moderados / evacuação parcial)',
    'Baixo (evento pouco provável / danos leves ou facilmente controláveis / não compromete a segurança das pessoas)'
  ];

  //Valida parametro cadastrado
  public formularioLiberado: boolean = false;
  public mensagemBloqueio: string | null = null;

  // Anos disponíveis para vigência (ano atual e ano seguinte)
  public anosVigencia: number[] = [];

  public ehEdit = false;
  public showCadastroModal = false;

  // Controle de inicialização
  private formInicializado = false;
  private planoParaCarregar: PlanoContingencia | null = null;

  // Arquivos
  public showModalDeletarArquivo = false;
  public showModalVisualizarArquivo = false;
  public arquivoVisualizando: ArquivoAzure | undefined;
  public arquivoRemover: ArquivoAzure | undefined;
  public codigoArquivoRemover: number | null = null;
  public riscoIndexAtual: number | undefined;

  private fb = inject(FormBuilder);

  public colunasGrid = [
    {
      title: 'Ano',
      field: 'dataInclusao',
      width: 80,
      hozAlign: "center",
      headerHozAlign: "center",
      formatter: (cell: any) => {
        const value = cell.getValue();
        if (!value) return '';
        const date = new Date(value);
        return date.getFullYear();
      }
    },
    { title: 'Nome da Escola', field: 'nmEscola', hozAlign: "center", headerHozAlign: "center" },
    { title: 'Nome', field: 'nomeResponsavel', hozAlign: "center", headerHozAlign: "center" },
    {
      title: 'Data de registro',
      field: 'dataInclusao',
      hozAlign: "center",
      headerHozAlign: "center",
      formatter: (cell: any) => {
        const value = cell.getValue();
        if (!value) return '';
        const date = new Date(value);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
      }
    },
    { title: 'Vigência', field: 'vigencia', hozAlign: "center", headerHozAlign: "center" },
    {
      title: 'Status',
      field: 'status',
      hozAlign: "center",
      headerHozAlign: "center",
      formatter: (cell: any) => {
        const value = cell.getValue();
        const statusMap: { [key: number]: string } = {
          0: 'Pendente',
          1: 'Aprovado',
          2: 'Devolvido para ajustes',
          3: 'Novo',
          4: 'Aguardando Validação Supervisor de Ensino',
          5: 'Aguardando validação PEC CONVIVA',
          6: 'Devolvido para ajustes'
        };
        const statusText = statusMap[value] ?? String(value);
        // Cores: Novo=azul, Aguardando Supervisor=laranja, Aprovado=verde, Devolvido/Reprovado=vermelho
        if (value === 3) {
          return '<span style="width: 10px; height: 10px; border-radius: 50%; background-color: #006ebd; display: inline-block; margin-right: 8px;"></span>' + statusText;
        }
        if (value === 4 || value === 5) {
          return '<span style="width: 10px; height: 10px; border-radius: 50%; background-color: #F57E3A; display: inline-block; margin-right: 8px;"></span>' + statusText;
        }
        if (value === 1) {
          return '<span style="width: 10px; height: 10px; border-radius: 50%; background-color: #28a745; display: inline-block; margin-right: 8px;"></span>' + statusText;
        }
        if (value === 2 || value === 6) {
          return '<span style="width: 10px; height: 10px; border-radius: 50%; background-color: #dc3545; display: inline-block; margin-right: 8px;"></span>' + statusText;
        }
        return statusText;
      }
    },
    {
      title: 'Ações',
      field: 'visualizar',
      width: 110,
      hozAlign: "center",
      headerHozAlign: "center",
      headerSort: false,
      cssClass: "col-acoes",
      formatter: (cell: any) => {
        const data = cell.getRow().getData();
        const status = Number(data.status ?? data.Status ?? 0);
        const aguardandoValidacao = status === PlanoStatus.AguardandoValidacaoSupervisor
          || status === PlanoStatus.AguardandoValidacaoPecConviva;
        // Editar: sempre visível (Aguardando = somente leitura; Aprovado = apenas anexos/riscos).
        const mostrarEditar = true;
        // Enviar para validação: Novo (3), Reprovado (2), Devolvido (6).
        const mostrarEnviar = status === 2 || status === 3 || status === 6;
        // Excluir: oculto se Aprovado (1) ou aguardando validação (4/5).
        const mostrarExcluir = status !== 1 && !aguardandoValidacao;

        const partes: string[] = ['<i class="fa-solid fa-eye" title="Visualizar"></i>'];
        if (mostrarEditar) {
          const tituloEditar = aguardandoValidacao ? 'Visualizar (somente leitura)' : 'Editar';
          partes.push(`<i class="fa-solid fa-edit" title="${tituloEditar}"></i>`);
        }
        if (mostrarEnviar) {
          partes.push('<i class="fa-solid fa-arrows-rotate" title="Enviar para Validação"></i>');
        }
        if (mostrarExcluir) {
          partes.push('<i class="fa-solid fa-trash" title="Excluir"></i>');
        }

        return `<div style="display: flex; justify-content: center; align-items: center; gap: 10px; flex-wrap: nowrap; white-space: nowrap;">${partes.join('')}</div>`;
      },
      cellClick: (e: any, cell: any) => this.OnClickAcao(e, cell)
    }
  ];

  constructor() {
    this.config.notFoundText = "Não encontrado";
    this.userLogado = this.authService.getUser();

    if (this.userLogado != null) {
      this.atribuicoesLogin = this.userLogado?.DadosUsuario[0];
    }
  }

  private OnClickAcao(e: any, cell: any) {
    const row = cell.getRow().getData();
    const target = e.target;
    const idPlano = row.cdPlano;
    const statusPlano = row.status;

    if (target.classList.contains('fa-eye')) {
      this.abrirModalVisualizar(idPlano);
    }

    if (target.classList.contains('fa-edit')) {
      this.abrirModalEditar(idPlano);
    }

    if (target.classList.contains('fa-arrows-rotate')) {
      const ano = row.vigencia;
      const escola = row.nmEscola;
      this.abrirModalEnviarValidacao(idPlano, ano, escola);
    }

    if (target.classList.contains('fa-trash')) {
      const status = Number(row.status ?? row.Status ?? 0);
      if (this.estaAguardandoValidacao(status)) {
        this.toastr.warning('Não é possível excluir o plano enquanto ele estiver aguardando validação.');
        return;
      }
      const ano = row.vigencia;
      const escola = row.nmEscola;
      this.abrirModalEliminar(idPlano, ano, escola);
    }
  }

  public get form() {
    return this.formCadastrar.controls;
  }
  get riscosForm(): FormArray {
    return this.formCadastrar.get('riscos') as FormArray;
  }

  public get formEdit() {
    return this.formEditar.controls;
  }
  get riscosFormEditar(): FormArray {
    return this.formEditar.get('riscos') as FormArray;
  }

  private getAnosPermitidosVigencia(): number[] {
    const anoAtual = new Date().getFullYear();
    return [anoAtual, anoAtual + 1];
  }

  private getAnoPadraoVigencia(): number {
    const anoAtual = new Date().getFullYear();
    return this.anosVigencia.includes(anoAtual) ? anoAtual : this.anosVigencia[0];
  }

  private normalizarAnoVigencia(valor: unknown): number {
    const ano = Number(valor);
    if (Number.isInteger(ano) && this.anosVigencia.includes(ano)) {
      return ano;
    }

    return this.getAnoPadraoVigencia();
  }

  private vigenciaPermitidaValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (control.value === null || control.value === undefined || control.value === '') {
        return null;
      }

      const ano = Number(control.value);
      if (!Number.isInteger(ano) || !this.anosVigencia.includes(ano)) {
        return { vigenciaInvalida: true };
      }

      return null;
    };
  }

  private protegerVigenciaContraManipulacao(form: FormGroup): void {
    const vigenciaControl = form.get('vigencia');
    if (!vigenciaControl) return;

    vigenciaControl.valueChanges.subscribe(valor => {
      if (valor === null || valor === undefined || valor === '') {
        return;
      }

      const normalizado = this.normalizarAnoVigencia(valor);
      if (Number(valor) !== normalizado) {
        vigenciaControl.setValue(normalizado, { emitEvent: false });
      }
    });
  }

  /** Indica se o plano está aguardando validação (status 4 ou 5). */
  private estaAguardandoValidacao(status?: number | null): boolean {
    const n = Number(status ?? this.statusPlano ?? (this.planoContingencia as any)?.status ?? 0);
    return n === PlanoStatus.AguardandoValidacaoSupervisor || n === PlanoStatus.AguardandoValidacaoPecConviva;
  }

  async ngOnInit() {
    // Somente leitura: Aprovado (sem modo anexos) ou aguardando validação (4/5).
    // Quando somenteAnexosERiscos, não forçar ehReadOnly para não bloquear anexos.
    if (!this.ehReadOnly && !this.somenteAnexosERiscos) {
      const status = Number(this.statusPlano);
      this.ehReadOnly = status === PlanoStatus.Aprovado || this.estaAguardandoValidacao(status);
    }

    // Inicializar anos disponíveis (ano atual e ano seguinte)
    this.anosVigencia = this.getAnosPermitidosVigencia();

    this.dtOptions = {
      deferRender: true,
      destroy: true,
      processing: true,
      paging: true,
      dom: 'Bfrtip', // garante filtros + botões no topo
      language: {
        url: 'https://cdn.datatables.net/plug-ins/1.11.5/i18n/pt-BR.json'
      },
      lengthMenu: [
        [10, 25, 50, -1],
        ['10 linhas', '25 linhas', '50 linhas', 'Tudo']
      ],
      buttons: [
        'pageLength',
        {
          extend: 'print',
          text: 'Imprimir',
          stripHtml: false,
          exportOptions: {
            columns: ':visible'
          }
        },
        {
          extend: 'excel',
          text: 'Excel',
          exportOptions: {
            columns: ':visible'
          }
        },
        {
          extend: 'pdf',
          text: 'PDF',
          orientation: 'landscape',
          exportOptions: {
            columns: ':visible'
          }
        }
      ]
    };

    this.formCadastrar = new FormGroup({
      codigoDiretoria: new FormControl({ value: null, disabled: this.ehReadOnly }, [Validators.required]),
      codigoEscola: new FormControl({ value: null, disabled: this.ehReadOnly }, [Validators.required]),
      vigencia: new FormControl({ value: this.getAnoPadraoVigencia(), disabled: this.ehReadOnly }, [Validators.required, this.vigenciaPermitidaValidator()]),
      nomeResponsavel: new FormControl({ value: null, disabled: this.ehReadOnly }, [Validators.required, Validators.maxLength(150)]),
      cienciaResponsaveis: new FormControl({ value: false, disabled: this.ehReadOnly }, [Validators.requiredTrue]),
      comite: new FormControl({ value: null, disabled: this.ehReadOnly }, [Validators.required, Validators.minLength(10), Validators.maxLength(500)]),
      riscos: new FormArray([])
    });

    this.formCadastrar.get('comite')?.valueChanges.subscribe(val => {
      this.qtdeCaracteresComite = val ? val.length : 0;
    });

    this.formEditar = new FormGroup({
      cdPlano: new FormControl(null),
      codigoDiretoria: new FormControl(null, [Validators.required]),
      codigoEscola: new FormControl(null, [Validators.required]),
      vigencia: new FormControl(this.getAnoPadraoVigencia(), [Validators.required, this.vigenciaPermitidaValidator()]),
      nomeResponsavel: new FormControl(null, [Validators.required, Validators.maxLength(150)]),
      cienciaResponsaveis: new FormControl(false, [Validators.requiredTrue]),
      comite: new FormControl(null, [Validators.required, Validators.minLength(10), Validators.maxLength(500)]),
      riscos: new FormArray([])
    });

    this.protegerVigenciaContraManipulacao(this.formCadastrar);
    this.protegerVigenciaContraManipulacao(this.formEditar);

    this.formEditar.get('comite')?.valueChanges.subscribe(val => {
      this.qtdeCaracteresComiteEditar = val ? val.length : 0;
    });

    this.formInicializado = true;
    if (this.planoParaCarregar) {
      this.carregarPlanoNoFormulario(this.planoParaCarregar);
      this.planoParaCarregar = null;
    }

    this.spinnerService.show();
    await this.validarPeriodoLiberacaoPlanoContingencia();
    await this.getDiretorias();
    await this.getEscolas();
    await this.PesquisarPlanos(true);
    this.spinnerService.hide();

    // Verifica se deve abrir o modal automaticamente (navegação da tela de consulta)
    if (!this.ehModal) {
      this.route.queryParams.subscribe((params: any) => {
        if (params['openModal'] === 'true') {
          setTimeout(() => this.OnOpenModal(), 100);
          // Remove o query param da URL
          this.router.navigate([], { relativeTo: this.route, queryParams: {} });
        }
      });
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['planoContingencia'] && this.planoContingencia) {
      if (this.formInicializado) {
        // Se o formulário já foi inicializado, carrega imediatamente
        this.carregarPlanoNoFormulario(this.planoContingencia);
      } else {
        // Senão, guarda para carregar depois do ngOnInit
        this.planoParaCarregar = this.planoContingencia;
      }
    }

    if (changes['ehReadOnly'] && changes['ehReadOnly'].currentValue) {
      // Recarrega o formulário em modo readonly se já existe um plano
      if (this.planoContingencia) {
        if (this.formInicializado) {
          this.carregarPlanoNoFormulario(this.planoContingencia);
        } else {
          this.planoParaCarregar = this.planoContingencia;
        }
      }
    }

    if (changes['somenteAnexosERiscos'] && this.planoContingencia && this.formInicializado) {
      // Cenário 2: reaplicar restrições de apenas anexos/riscos ao trocar o flag
      this.carregarPlanoNoFormulario(this.planoContingencia);
    }
  }

  private carregarPlanoNoFormulario(plano: PlanoContingencia): void {
    if (!this.formCadastrar) return;

    this.formCadastrar.patchValue({
      codigoDiretoria: plano.cdDiretoria,
      codigoEscola: plano.cdEscola,
      vigencia: this.normalizarAnoVigencia(plano.vigencia),
      nomeResponsavel: plano.nomeResponsavel,
      comite: plano.comite,
      cienciaResponsaveis: true
    });

    // Desabilita ou habilita campos principais: readonly total ou Cenário 2 (apenas anexos/riscos)
    const desabilitarCamposPlano = this.ehReadOnly || this.somenteAnexosERiscos;
    if (desabilitarCamposPlano) {
      this.formCadastrar.get('codigoDiretoria')?.disable();
      this.formCadastrar.get('codigoEscola')?.disable();
      this.formCadastrar.get('vigencia')?.disable();
      this.formCadastrar.get('nomeResponsavel')?.disable();
      this.formCadastrar.get('comite')?.disable();
      this.formCadastrar.get('cienciaResponsaveis')?.disable();
    } else {
      this.formCadastrar.get('codigoDiretoria')?.enable();
      this.formCadastrar.get('codigoEscola')?.enable();
      this.formCadastrar.get('vigencia')?.enable();
      this.formCadastrar.get('nomeResponsavel')?.enable();
      this.formCadastrar.get('comite')?.enable();
      this.formCadastrar.get('cienciaResponsaveis')?.enable();
    }

    // Carregar riscos se existirem
    if (plano.riscos && plano.riscos.length > 0) {
      const riscosFormArray = this.formCadastrar.get('riscos') as FormArray;
      riscosFormArray.clear();

      // Cenário 2: quando somenteAnexosERiscos, riscos existentes ficam só-leitura exceto anexos; novos riscos são editáveis
      const desabilitarCamposRisco = this.ehReadOnly || this.somenteAnexosERiscos;
      const desabilitarApenasArquivos = this.ehReadOnly; // arquivos habilitados quando somenteAnexosERiscos

      plano.riscos.forEach(risco => {
        const riscoFormGroup = new FormGroup({
          // Seção Risco
          perigo: new FormControl({ value: risco.perigo || [], disabled: desabilitarCamposRisco }, [Validators.required, Validators.minLength(1)]),
          vulnerabilidade: new FormControl({ value: risco.vulnerabilidade || [], disabled: desabilitarCamposRisco }, [Validators.required, Validators.minLength(1)]),
          justificativaVulnerabilidade: new FormControl({ value: risco.justificativaVulnerabilidade, disabled: desabilitarCamposRisco }, [Validators.required, Validators.minLength(10), Validators.maxLength(500)]),
          dano: new FormControl({ value: risco.dano || [], disabled: desabilitarCamposRisco }, [Validators.required, Validators.minLength(1)]),
          justificativaDano: new FormControl({ value: risco.justificativaDano, disabled: desabilitarCamposRisco }, [Validators.required, Validators.minLength(10), Validators.maxLength(500)]),
          grauRisco: new FormControl({ value: risco.grauRisco, disabled: desabilitarCamposRisco }, [Validators.required]),
          justificativaGrauRisco: new FormControl({ value: risco.justificativaGrauRisco, disabled: desabilitarCamposRisco }, [Validators.required, Validators.minLength(10), Validators.maxLength(500)]),

          // Ações antes do fato
          prevencao: new FormControl({ value: risco.prevencao, disabled: desabilitarCamposRisco }, [Validators.required, Validators.minLength(10), Validators.maxLength(500)]),
          mitigacao: new FormControl({ value: risco.mitigacao, disabled: desabilitarCamposRisco }, [Validators.required, Validators.minLength(10), Validators.maxLength(500)]),
          preparacao: new FormControl({ value: risco.preparacao, disabled: desabilitarCamposRisco }, [Validators.required, Validators.minLength(10), Validators.maxLength(500)]),

          // Ações durante o fato
          evacuacaoPredio: new FormControl({ value: risco.evacuacaoPredio, disabled: desabilitarCamposRisco }, [Validators.required, Validators.minLength(10), Validators.maxLength(500)]),
          acionamentoOrgaos: new FormControl({ value: risco.acionamentoOrgaos, disabled: desabilitarCamposRisco }, [Validators.required, Validators.minLength(10), Validators.maxLength(500)]),
          isolamentoAreas: new FormControl({ value: risco.isolamentoAreas, disabled: desabilitarCamposRisco }, [Validators.required, Validators.minLength(10), Validators.maxLength(500)]),
          comunicacaoURE: new FormControl({ value: risco.comunicacaoURE, disabled: desabilitarCamposRisco }, [Validators.required, Validators.minLength(10), Validators.maxLength(500)]),

          // Avaliação do Fato Ocorrido
          avaliacaoDanos: new FormControl({ value: risco.avaliacaoDanos, disabled: desabilitarCamposRisco }, [Validators.required, Validators.minLength(10), Validators.maxLength(500)]),
          limpezaReorganizacao: new FormControl({ value: risco.limpezaReorganizacao, disabled: desabilitarCamposRisco }, [Validators.required, Validators.minLength(10), Validators.maxLength(500)]),
          apoioPsicossocial: new FormControl({ value: risco.apoioPsicossocial, disabled: desabilitarCamposRisco }, [Validators.required, Validators.minLength(10), Validators.maxLength(500)]),
          revisaoPlano: new FormControl({ value: risco.revisaoPlano, disabled: desabilitarCamposRisco }, [Validators.required, Validators.minLength(10), Validators.maxLength(500)]),

          // Encaminhamentos
          encaminhamentos: new FormControl({ value: risco.encaminhamentos, disabled: desabilitarCamposRisco }, [Validators.required, Validators.minLength(10), Validators.maxLength(500)]),

          // Sistema de alerta/comunicação
          comunicacaoInterna: new FormControl({ value: risco.comunicacaoInterna, disabled: desabilitarCamposRisco }, [Validators.required, Validators.minLength(10), Validators.maxLength(500)]),
          comunicacaoExterna: new FormControl({ value: risco.comunicacaoExterna, disabled: desabilitarCamposRisco }, [Validators.required, Validators.minLength(10), Validators.maxLength(500)]),
          meiosSonoros: new FormControl({ value: risco.meiosSonoros, disabled: desabilitarCamposRisco }, [Validators.required, Validators.minLength(10), Validators.maxLength(500)]),

          // Arquivos: habilitado quando somenteAnexosERiscos (permitir inclusão de anexos)
          arquivos: new FormControl({ value: risco.arquivos || [], disabled: desabilitarApenasArquivos })
        });
        riscosFormArray.push(riscoFormGroup);
      });
    }
  }

  public async getDiretorias() {
    this.spinnerService.show();
    const result = await lastValueFrom(
      this.escolaService.getDiretoriaPorTipoDiretoria()
    ).catch(err => this.ConvivaErrors.handleResultError(err));

    if (!result.isSucess) {
      this.toastr.error(result.message, result.title);
      this.spinnerService.hide();
      return;
    }

    this.diretorias = result.data.filter(
      (d: any) => d.codigoDiretoria === this.userLogado?.codigoDiretoria
    );

    this.formCadastrar.get('codigoDiretoria')?.setValue(this.userLogado?.codigoDiretoria);

    this.spinnerService.hide();
  }


  public async getEscolas() {
    const codigoDE = this.userLogado?.codigoDiretoria;
    if (codigoDE) {
      this.spinnerService.show();
      const result = await lastValueFrom(
        this.escolaService.getEscolasPorCodigoDiretoria(codigoDE)
      ).catch(err => this.ConvivaErrors.handleResultError(err));

      if (!result.isSucess) {
        this.toastr.error(result.message, result.title);
        this.spinnerService.hide();
        return;
      }

      this.escolas = result.data;

      if (this.userLogado?.codigoEscola) {
        const existe = this.escolas.find(
          e => e.codigoEscola === this.userLogado!.codigoEscola
        );

        if (existe) {
          this.formCadastrar.get("codigoEscola")?.setValue(this.userLogado.codigoEscola);
          this.formCadastrar.get("codigoEscola")?.disable();
        }
      }

      this.spinnerService.hide();
    }
  }

  public adicionarRisco() {
    const riscoGroup = this.fb.group({
      // Seção Risco
      perigo: [[], [Validators.required, Validators.minLength(1)]],
      vulnerabilidade: [[], [Validators.required, Validators.minLength(1)]],
      justificativaVulnerabilidade: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(500)]],
      dano: [[], [Validators.required, Validators.minLength(1)]],
      justificativaDano: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(500)]],
      grauRisco: ['', [Validators.required]],
      justificativaGrauRisco: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(500)]],

      // Ações antes do fato
      prevencao: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(500)]],
      mitigacao: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(500)]],
      preparacao: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(500)]],

      // Ações durante o fato
      evacuacaoPredio: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(500)]],
      acionamentoOrgaos: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(500)]],
      isolamentoAreas: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(500)]],
      comunicacaoURE: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(500)]],

      // Avaliação do Fato Ocorrido
      avaliacaoDanos: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(500)]],
      limpezaReorganizacao: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(500)]],
      apoioPsicossocial: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(500)]],
      revisaoPlano: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(500)]],

      // Encaminhamentos
      encaminhamentos: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(500)]],

      // Sistema de alerta/comunicação
      comunicacaoInterna: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(500)]],
      comunicacaoExterna: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(500)]],
      meiosSonoros: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(500)]],

      // Arquivos
      arquivos: [[]]
    });

    this.riscosForm.push(riscoGroup);
  }


  public removerRisco(index: number) {
    this.abrirModalRemoverRisco(index);
  }

  public abrirModalRemoverRisco(index: number) {
    const comite = this.formCadastrar.get('comite')?.value;
    this.nomeRiscoModal = comite || 'Comitê não identificado';
    this.indexRiscoRemover = index;
    this.showModalRemoverRisco = true;
  }

  public confirmarRemoverRisco() {
    if (this.indexRiscoRemover !== null) {
      this.riscosForm.removeAt(this.indexRiscoRemover);
      this.fecharModalRemoverRisco();
    }
  }

  public fecharModalRemoverRisco() {
    this.showModalRemoverRisco = false;
    this.indexRiscoRemover = null;
    this.nomeRiscoModal = '';
  }

  public adicionarRiscoEditar() {
    const riscoGroup = this.fb.group({
      cdRisco: [0], // 0 for new riscos
      // Seção Risco
      perigo: [[], [Validators.required, Validators.minLength(1)]],
      vulnerabilidade: [[], [Validators.required, Validators.minLength(1)]],
      justificativaVulnerabilidade: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(500)]],
      dano: [[], [Validators.required, Validators.minLength(1)]],
      justificativaDano: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(500)]],
      grauRisco: ['', [Validators.required]],
      justificativaGrauRisco: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(500)]],

      // Ações antes do fato
      prevencao: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(500)]],
      mitigacao: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(500)]],
      preparacao: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(500)]],

      // Ações durante o fato
      evacuacaoPredio: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(500)]],
      acionamentoOrgaos: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(500)]],
      isolamentoAreas: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(500)]],
      comunicacaoURE: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(500)]],

      // Avaliação do Fato Ocorrido
      avaliacaoDanos: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(500)]],
      limpezaReorganizacao: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(500)]],
      apoioPsicossocial: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(500)]],
      revisaoPlano: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(500)]],

      // Encaminhamentos
      encaminhamentos: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(500)]],

      // Sistema de alerta/comunicação
      comunicacaoInterna: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(500)]],
      comunicacaoExterna: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(500)]],
      meiosSonoros: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(500)]],

      // Arquivos
      arquivos: [[]]
    });

    this.riscosFormEditar.push(riscoGroup);
  }

  public removerRiscoEditar(index: number) {
    this.abrirModalRemoverRiscoEditar(index);
  }

  public abrirModalRemoverRiscoEditar(index: number) {
    const comite = this.formEditar.get('comite')?.value;
    this.nomeRiscoModal = comite || 'Comitê não identificado';
    this.indexRiscoRemover = index;
    this.showModalRemoverRisco = true;
  }

  public confirmarRemoverRiscoEditar() {
    if (this.indexRiscoRemover !== null) {
      this.riscosFormEditar.removeAt(this.indexRiscoRemover);
      this.fecharModalRemoverRisco();
    }
  }

  public OnChangeCountLetters() {
    const descricao = this.formCadastrar.get('comite')!.value;
    if (descricao != null) {
      this.qtdeCaracteresComite = descricao.length;
    }
  }

  public OnLimpar() {
    this.formCadastrar.reset({
      codigoDiretoria: this.userLogado?.codigoDiretoria,
      codigoEscola: this.userLogado?.codigoEscola
    });
    this.riscosForm.clear();
    this.qtdeCaracteresComite = 0;
  }

  public async OnSalvar() {
    this.submitted = true;
    this.formCadastrar.get('vigencia')?.setValue(this.normalizarAnoVigencia(this.formCadastrar.get('vigencia')?.value), { emitEvent: false });

    if (this.estaAguardandoValidacao()) {
      this.toastr.warning('Não é possível alterar o plano enquanto ele estiver aguardando validação.');
      return;
    }

    // Marca todos os campos como touched para exibir erros de validação
    this.formCadastrar.markAllAsTouched();

    for (let i = 0; i < this.riscosForm.length; i++) {
      const riscoGroup = this.riscosForm.at(i) as FormGroup;
      riscoGroup.markAllAsTouched();
    }

    if (!this.formularioLiberado) {
      this.toastr.warning('Formulário bloqueado — fora do período de cadastro.');
      return;
    }

    if (this.riscosForm.length === 0) {
      this.toastr.error('É necessário adicionar pelo menos um risco.');
      this.rolarParaPrimeiroCampoInvalido();
      return;
    }

    if (this.formCadastrar.invalid) {
      const nomesCamposPlano: Record<string, string> = {
        codigoDiretoria: 'URE',
        codigoEscola: 'Escola',
        vigencia: 'Vigência',
        nomeResponsavel: 'Nome do Responsável',
        cienciaResponsaveis: 'Ciência dos responsáveis',
        comite: 'Comitê'
      };

      const camposPlanoInvalidos = Object.keys(nomesCamposPlano)
        .filter(c => this.formCadastrar.get(c)?.invalid)
        .map(c => nomesCamposPlano[c]);

      if (camposPlanoInvalidos.length > 0) {
        this.toastr.error(
          `Preencha os campos obrigatórios: ${camposPlanoInvalidos.join(', ')}.`
        );
      }

      const nomesCampos: Record<string, string> = {
        perigo: 'Perigo',
        vulnerabilidade: 'Vulnerabilidade',
        justificativaVulnerabilidade: 'Justificativa de vulnerabilidade',
        dano: 'Dano',
        justificativaDano: 'Justificativa de dano',
        grauRisco: 'Grau de risco',
        justificativaGrauRisco: 'Justificativa de grau de risco',
        prevencao: 'Prevenção',
        mitigacao: 'Mitigação',
        preparacao: 'Preparação',
        evacuacaoPredio: 'Evacuação do Prédio',
        acionamentoOrgaos: 'Acionamento dos órgãos',
        isolamentoAreas: 'Isolamento das áreas',
        comunicacaoURE: 'Comunicação com URE',
        avaliacaoDanos: 'Avaliação dos danos',
        limpezaReorganizacao: 'Limpeza e reorganização',
        apoioPsicossocial: 'Apoio psicossocial',
        revisaoPlano: 'Revisão do plano',
        encaminhamentos: 'Encaminhamentos',
        comunicacaoInterna: 'Comunicação interna',
        comunicacaoExterna: 'Comunicação externa',
        meiosSonoros: 'Meios sonoros/visuais/digitais'
      };

      for (let i = 0; i < this.riscosForm.length; i++) {
        const riscoGroup = this.riscosForm.at(i) as FormGroup;
        if (riscoGroup.invalid) {
          const erros = Object.keys(riscoGroup.controls)
            .filter(c => riscoGroup.get(c)?.invalid)
            .map(c => nomesCampos[c] ?? c);

          this.toastr.error(
            `O risco ${i + 1} possui campos inválidos: ${erros.join(', ')}. Verifique os requisitos (mín. 10 caracteres).`
          );
        }
      }

      this.rolarParaPrimeiroCampoInvalido();
      return;
    }


    this.spinnerService.show();

    const dir = this.diretorias.filter(r => r.codigoDiretoria == this.formCadastrar.get('codigoDiretoria')?.value)[0];
    const esc = this.escolas.filter(r => r.codigoEscola == this.formCadastrar.get('codigoEscola')?.value)[0];

    // Verifica se é edição: deve ter ehEdicao true E planoContingencia com ID válido
    const isEdicao = this.ehEdicao && this.planoContingencia && this.planoContingencia.cdPlano > 0;

    const objetoPlano: PlanoContingencia = {
      cdPlano: isEdicao ? this.planoContingencia!.cdPlano : 0,
      cdDiretoria: dir?.codigoDiretoria ?? 0,
      nmDiretoria: dir?.nomeDiretoria ?? '',
      cdEscola: esc?.codigoEscola ?? 0,
      nmEscola: esc?.nomeEscola ?? '',
      vigencia: this.formCadastrar.get('vigencia')?.value,
      nomeResponsavel: this.formCadastrar.get('nomeResponsavel')?.value,
      cienciaResponsaveis: this.formCadastrar.get('cienciaResponsaveis')?.value,
      comite: this.formCadastrar.get('comite')?.value,
      riscos: this.riscosForm.value,
      codigoPerfil: this.atribuicoesLogin.CodigoPerfil,
      nomePerfil: this.atribuicoesLogin.NomePerfil,
      email: this.atribuicoesLogin.Email,
      status: isEdicao ? this.planoContingencia!.status : PlanoStatus.Novo
    };

    // Chama o endpoint apropriado baseado no modo (edição ou cadastro)
    const result = await lastValueFrom(
      isEdicao
        ? this.planoContingenciaService.setAtualizarPlano(objetoPlano)
        : this.planoContingenciaService.setCadastrarPlano(objetoPlano)
    ).catch((err) => {
      return this.ConvivaErrors.handleResultError(err);
    });

    if (!result.isSucess) {
      this.toastr.error(result.message, result.title);
      this.spinnerService.hide();
      return;
    }

    this.spinnerService.hide();
    this.toastr.success(
      isEdicao
        ? 'Plano de Contingência atualizado com sucesso!'
        : 'Plano de Contingência salvo com sucesso!'
    );

    // Limpa o formulário
    this.submitted = false;
    this.OnLimpar();

    // Fecha o modal (emite evento se for modal, senão fecha diretamente)
    if (this.ehModal) {
      this.fechar.emit();
    } else {
      this.FecharCadastroModal();
    }

    // Recarrega o grid
    await this.PesquisarPlanos();
  }

  public async PesquisarPlanos(isInitialLoad: boolean = false) {
    this.spinnerService.show();
    this.submitted = true;

    if (this.formCadastrar.get('codigoDiretoria')?.invalid ||
      this.formCadastrar.get('codigoEscola')?.invalid) {
      this.showPesquisa = false;
      this.spinnerService.hide();
      return;
    }

    this.showPesquisa = true;

    const parametros = {
      codigoPolo: 0,
      codigoDiretoria: this.form?.codigoDiretoria.value,
      codigoEscola: this.form?.codigoEscola.value ?? 0
    };

    const response = await lastValueFrom(
      this.planoService.getPlanos(parametros.codigoPolo, parametros.codigoDiretoria, parametros.codigoEscola)
    ).catch((err) => this.ConvivaErrors.handleResultError(err));

    if (!response.isSucess) {
      this.toastr.error(response.message);
      this.spinnerService.hide();
      return;
    }

    this.lstPlanos = response.data;
    this.spinnerService.hide();
  }

  public async abrirModalVisualizar(item: number) {
    this.spinnerService.show();

    const response = await lastValueFrom(
      this.planoService.getPlanoById(item)
    ).catch((err) => this.ConvivaErrors.handleResultError(err));

    if (!response.isSucess) {
      this.toastr.error(response.message);
      this.spinnerService.hide();
      return;
    }

    this.planoSelecionado = response.data;
    this.ehEdit = false;
    this.ehReadOnly = true;
    this.showCadastroModal = true;
    this.tituloAcaoModal = 'Visualizar plano';
    this.statusPlano = response.data.status;

    this.spinnerService.hide();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  public fecharModalVisualizar() {
    this.showModalVisualizar = false;
    this.planoSelecionado = null;
    this.riscosSelecionados = [];
    this.riscoAberto = null;
  }

  /** Abre o modal "Histórico de atualizações" (usa planoContingencia?.logs no cadastro). */
  public abrirModalHistorico(): void {
    this.showModalHistorico = true;
  }

  /** Fecha o modal Histórico de atualizações. */
  public fecharModalHistorico(): void {
    this.showModalHistorico = false;
  }

  /** Indica se o responsável no log parece ser um ID (apenas dígitos) para estilização. */
  public ehIdResponsavel(nome: string | undefined): boolean {
    if (!nome || typeof nome !== 'string') return false;
    return /^\d+$/.test(nome.trim());
  }

  /** Texto do tipo de operação no histórico (I=Cadastro, U=Edição, A=Aprovação/Envio, R=Reprovação, D=Exclusão). */
  public getTextoOperacaoLog(log: LogPlanoContingencia): string {
    const op = (log.tipoOperacao ?? '').toUpperCase();
    const ap = String(log.tipoAprovacao ?? '');
    if (op === 'I') return 'Cadastro';
    if (op === 'U') return 'Edição';
    if (op === 'D') return 'Exclusão';
    if (op === 'R') return 'Reprovação / Devolvido para ajustes';
    if (op === 'A') return (ap === '2' || Number(log.tipoAprovacao) === 2) ? 'Enviado para validação' : 'Aprovação';
    return log.tipoOperacao || 'Atualização';
  }

  public abrirModalEliminar(codigoPlano: number, anoPlano: number, escolaPlano: string) {
    this.codigoPlanoSelecionado = codigoPlano;
    this.anoModal = String(anoPlano);
    this.escolaModal = escolaPlano;
    this.descricaoModal = "Tem certeza de que deseja excluir o Plano de Contingência?";
    this.showModalEliminar = true;
  }

  public async abrirModalEditar(codigoPlano: number) {
    this.spinnerService.show();

    const response = await lastValueFrom(
      this.planoService.getPlanoById(codigoPlano)
    ).catch((err) => this.ConvivaErrors.handleResultError(err));

    if (!response.isSucess) {
      this.toastr.error(response.message);
      this.spinnerService.hide();
      return;
    }

    this.planoSelecionado = response.data;
    this.ehEdit = true;
    const status = Number((response.data as any).status ?? (response.data as any).Status ?? 0);
    const aguardandoValidacao = this.estaAguardandoValidacao(status);
    this.ehReadOnly = aguardandoValidacao;
    this.somenteAnexosERiscosModal = status === PlanoStatus.Aprovado;
    this.tituloAcaoModal = aguardandoValidacao
      ? 'Visualizar Plano de Contingência'
      : this.somenteAnexosERiscosModal
        ? 'Editar Plano (apenas anexos e riscos)'
        : 'Editar plano';
    this.statusPlano = response.data.status;
    this.showCadastroModal = true;

    this.spinnerService.hide();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  public async OnSalvarEditar() {
    this.submittedEditar = true;
    this.formEditar.get('vigencia')?.setValue(this.normalizarAnoVigencia(this.formEditar.get('vigencia')?.value), { emitEvent: false });

    if (this.estaAguardandoValidacao()) {
      this.toastr.warning('Não é possível alterar o plano enquanto ele estiver aguardando validação.');
      return;
    }

    if (!this.formEditar.get('cienciaResponsaveis')?.value) {
      this.toastr.error('Todos os envolvidos devem estar cientes para continuar.');
      return;
    }

    if (!this.formularioLiberado) {
      this.toastr.warning('Formulário bloqueado — fora do período de cadastro.');
      return;
    }

    if (this.riscosFormEditar.length === 0) {
      this.toastr.error('É necessário adicionar pelo menos um risco.');
      return;
    }

    if (this.formEditar.invalid) {
      if (this.formEditar.get('codigoDiretoria')?.invalid) {
        this.toastr.error('Selecione a Diretoria.');
        return;
      }
      if (this.formEditar.get('codigoEscola')?.invalid) {
        this.toastr.error('Selecione a Escola.');
        return;
      }
      if (this.formEditar.get('vigencia')?.invalid) {
        this.toastr.error('Informe uma Vigência válida (ano atual ou seguinte).');
        return;
      }
      if (this.formEditar.get('nomeResponsavel')?.invalid) {
        this.toastr.error('Informe o Nome do Responsável (campo obrigatório, máx. 150 caracteres).');
        return;
      }
      if (this.formEditar.get('comite')?.invalid) {
        this.toastr.error('O campo Comitê deve ter entre 10 e 500 caracteres.');
        return;
      }

      const nomesCampos: Record<string, string> = {
        perigo: 'Perigo',
        vulnerabilidade: 'Vulnerabilidade',
        justificativaVulnerabilidade: 'Justificativa de vulnerabilidade',
        dano: 'Dano',
        justificativaDano: 'Justificativa de dano',
        grauRisco: 'Grau de risco',
        justificativaGrauRisco: 'Justificativa de grau de risco',
        prevencao: 'Prevenção',
        mitigacao: 'Mitigação',
        preparacao: 'Preparação',
        evacuacaoPredio: 'Evacuação do Prédio',
        acionamentoOrgaos: 'Acionamento dos órgãos',
        isolamentoAreas: 'Isolamento das áreas',
        comunicacaoURE: 'Comunicação com URE',
        avaliacaoDanos: 'Avaliação dos danos',
        limpezaReorganizacao: 'Limpeza e reorganização',
        apoioPsicossocial: 'Apoio psicossocial',
        revisaoPlano: 'Revisão do plano',
        encaminhamentos: 'Encaminhamentos',
        comunicacaoInterna: 'Comunicação interna',
        comunicacaoExterna: 'Comunicação externa',
        meiosSonoros: 'Meios sonoros/visuais/digitais'
      };

      for (let i = 0; i < this.riscosFormEditar.length; i++) {
        const riscoGroup = this.riscosFormEditar.at(i) as FormGroup;
        if (riscoGroup.invalid) {
          const erros = Object.keys(riscoGroup.controls)
            .filter(c => riscoGroup.get(c)?.invalid)
            .map(c => nomesCampos[c] ?? c);

          this.toastr.error(
            `O risco ${i + 1} possui campos inválidos: ${erros.join(', ')}. Verifique os requisitos (mín. 10 caracteres, máx. 500).`
          );
          return;
        }
      }
    }

    this.spinnerService.show();

    const dir = this.diretorias.filter(r => r.codigoDiretoria == this.formEditar.get('codigoDiretoria')?.value)[0];
    const esc = this.escolas.filter(r => r.codigoEscola == this.formEditar.get('codigoEscola')?.value)[0];

    // Get riscos with cdRisco explicitly included
    const riscosData = this.riscosFormEditar.controls.map(control => {
      const value = control.value;
      return {
        cdRisco: value.cdRisco || 0,
        perigo: value.perigo,
        vulnerabilidade: value.vulnerabilidade,
        justificativaVulnerabilidade: value.justificativaVulnerabilidade,
        dano: value.dano,
        justificativaDano: value.justificativaDano,
        grauRisco: value.grauRisco,
        justificativaGrauRisco: value.justificativaGrauRisco,
        prevencao: value.prevencao,
        mitigacao: value.mitigacao,
        preparacao: value.preparacao,
        evacuacaoPredio: value.evacuacaoPredio,
        acionamentoOrgaos: value.acionamentoOrgaos,
        isolamentoAreas: value.isolamentoAreas,
        comunicacaoURE: value.comunicacaoURE,
        avaliacaoDanos: value.avaliacaoDanos,
        limpezaReorganizacao: value.limpezaReorganizacao,
        apoioPsicossocial: value.apoioPsicossocial,
        revisaoPlano: value.revisaoPlano,
        encaminhamentos: value.encaminhamentos,
        comunicacaoInterna: value.comunicacaoInterna,
        comunicacaoExterna: value.comunicacaoExterna,
        meiosSonoros: value.meiosSonoros,
        arquivos: value.arquivos || []
      };
    });

    const objetoPlano: PlanoContingencia = {
      cdPlano: this.codigoPlanoSelecionado ?? 0,
      cdDiretoria: dir?.codigoDiretoria ?? 0,
      nmDiretoria: dir?.nomeDiretoria ?? '',
      cdEscola: esc?.codigoEscola ?? 0,
      nmEscola: esc?.nomeEscola ?? '',
      vigencia: this.formEditar.get('vigencia')?.value,
      nomeResponsavel: this.formEditar.get('nomeResponsavel')?.value,
      cienciaResponsaveis: this.formEditar.get('cienciaResponsaveis')?.value,
      comite: this.formEditar.get('comite')?.value,
      riscos: riscosData,
      codigoPerfil: this.atribuicoesLogin.CodigoPerfil,
      nomePerfil: this.atribuicoesLogin.NomePerfil,
      email: this.atribuicoesLogin.Email,
      status: PlanoStatus.Novo
    };

    const result = await lastValueFrom(
      this.planoContingenciaService.setAtualizarPlano(objetoPlano)
    ).catch((err) => {
      return this.ConvivaErrors.handleResultError(err);
    });

    if (!result.isSucess) {
      this.toastr.error(result.message, result.title);
      this.spinnerService.hide();
      return;
    }

    this.spinnerService.hide();
    this.toastr.success('Plano de Contingência atualizado com sucesso!');
    this.fecharModalEditar();
    await this.PesquisarPlanos();
  }

  OnOpenModal() {
    this.ehEdit = true;
    this.showCadastroModal = true;
    this.tituloAcaoModal = 'Cadastrar plano';
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  public async FecharCadastroModal() {
    this.showCadastroModal = false;
    this.planoSelecionado = null;
    this.statusPlano = undefined;
    this.ehEdit = false;
    this.ehReadOnly = false;
    this.somenteAnexosERiscosModal = false;

    // Recarrega o grid ao fechar o formulário
    if (this.showPesquisa) {
      await this.PesquisarPlanos();
    }
  }

  public FecharModal() {
    if (this.ehModal) {
      this.fechar.emit();
    } else {
      this.FecharCadastroModal();
    }
  }

  private rolarParaPrimeiroCampoInvalido(): void {
    setTimeout(() => {
      const primeiroErro = document.querySelector(
        '.alert, .ng-invalid.ng-touched, .is-invalid'
      ) as HTMLElement | null;
      primeiroErro?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }

  public fecharModalEditar() {
    this.showModalEditar = false;
    this.codigoPlanoSelecionado = null;
    this.submittedEditar = false;
    this.riscosFormEditar.clear();
    this.formEditar.reset();
    this.qtdeCaracteresComiteEditar = 0;
  }

  public abrirRisco(index: number): void {
    this.riscoAberto = this.riscoAberto === index ? null : index;
  }

  public getNomeDiretoria(): string {
    const codigoDiretoria = this.formEditar.get('codigoDiretoria')?.value;
    const diretoria = this.diretorias.find(d => d.codigoDiretoria === codigoDiretoria);
    return diretoria?.nomeDiretoria || '';
  }

  public getNomeEscola(): string {
    const codigoEscola = this.formEditar.get('codigoEscola')?.value;
    const escola = this.escolas.find(e => e.codigoEscola === codigoEscola);
    return escola?.nomeEscola || '';
  }

  private formatDateForInput(date: string | Date): string {
    if (!date) return '';
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  public async confirmarAcaoEliminar() {
    this.showModalEliminar = false;
    if (!this.codigoPlanoSelecionado) return;
    const parametros = {
      codigoPlano: this.codigoPlanoSelecionado,
      codigoUsuario: this.userLogado?.codigoUsuario ?? 0,
      codigoPerfil: this.userLogado?.codigoPerfil ?? 0,
      nomePerfil: this.userLogado?.nomePerfil ?? ''
    };

    this.spinnerService.show();
    const result = await lastValueFrom(
      this.planoService.setEliminarPlano(parametros)
    ).catch((err) => {
      return this.ConvivaErrors.handleResultError(err);
    });
    if (!result.isSucess) {
      this.toastr.error(result.message);
      this.spinnerService.hide();
      return;
    }
    this.toastr.success('Plano de Contingência eliminado com sucesso!');
    this.spinnerService.hide();
    this.PesquisarPlanos(true);
    this.fecharModalEliminar();

  }

  public fecharModalEliminar() {
    this.showModalEliminar = false;
    this.codigoPlanoSelecionado = null;
    this.anoModal = '';
    this.escolaModal = '';
    this.descricaoModal = '';
  }

  public abrirModalEnviarValidacao(codigoPlano: number, anoPlano: number, escolaPlano: string) {
    this.codigoPlanoSelecionado = codigoPlano;
    this.anoModal = String(anoPlano);
    this.escolaModal = escolaPlano;
    this.descricaoModal = "Tem certeza de que deseja enviar para validação?";
    this.showModalEnviarValidacao = true;
  }

  public async confirmarEnviarValidacao() {
    this.showModalEnviarValidacao = false;
    if (!this.codigoPlanoSelecionado) return;

    const parametros = {
      codigoPlano: this.codigoPlanoSelecionado,
      codigoUsuario: this.userLogado?.codigoUsuario ?? 0,
      codigoPerfil: this.atribuicoesLogin.CodigoPerfil,
      nomePerfil: this.atribuicoesLogin.NomePerfil
    };

    this.spinnerService.show();
    const result = await lastValueFrom(
      this.planoService.setEnviarParaValidacao(parametros)
    ).catch((err) => {
      return this.ConvivaErrors.handleResultError(err);
    });

    if (!result.isSucess) {
      this.toastr.error(result.message);
      this.spinnerService.hide();
      return;
    }

    this.toastr.success('Plano de Contingência enviado para validação com sucesso!');
    this.spinnerService.hide();
    await this.PesquisarPlanos();
    this.codigoPlanoSelecionado = null;
  }

  public fecharModalEnviarValidacao() {
    this.showModalEnviarValidacao = false;
    this.codigoPlanoSelecionado = null;
    this.anoModal = '';
    this.escolaModal = '';
    this.descricaoModal = '';
  }

  private async validarPeriodoLiberacaoPlanoContingencia() {
    try {
      const response = await lastValueFrom(this.ParametroPeriodoService.getAllParametroPeriodo());
      if (!response.isSucess) {
        this.toastr.error(response.message);
        return;
      }

      const parametros = response.data.filter(
        (p: any) => p.codigoPlano === 1 && p.flAtivo // Plano 1 = Plano de Contingência
      );

      const hoje = new Date();
      const dentroDoPeriodo = parametros.some((p: any) => {
        const inicio = new Date(p.dtInicio);
        const fim = new Date(p.dtFim);
        return hoje >= inicio && hoje <= fim;
      });

      this.formularioLiberado = dentroDoPeriodo;
      if (!this.formularioLiberado) {
        if (!dentroDoPeriodo) {
          this.mensagemBloqueio = 'Fora do período de preenchimento do Plano de Contingência.';
        }
      }

    } catch (err) {
      this.ConvivaErrors.handleResultError(err);
    }
  }

  // Métodos para gerenciar arquivos
  public getArquivosRisco(riscoIndex: number): ArquivoAzure[] {
    if (riscoIndex >= 0 && riscoIndex < this.riscosForm.length) {
      const riscoControl = this.riscosForm.at(riscoIndex) as FormGroup;
      const arquivos = riscoControl.get('arquivos')?.value || [];
      return arquivos;
    }
    return [];
  }

  public async OnFileChange(event: any, riscoIndex: number) {
    const maxFileSize = 31 * 1024 * 1024; // 30 MB

    if (event.target.files.length > 0) {
      this.spinnerService.show();
      const formData = new FormData();
      const files = event.target.files;

      for (const file of files) {
        const fileName = file.name.split('.')[0];

        if (fileName.length > 30) {
          const fileInput = document.getElementById(`arquivos-${riscoIndex}`) as HTMLInputElement;
          if (fileInput) {
            fileInput.value = '';
          }
          this.toastr.warning('O nome do documento não pode ter mais de 30 caracteres.');
          this.spinnerService.hide();
          return;
        }

        if (file.size > maxFileSize) {
          this.toastr.warning('O tamanho máximo do documento é 30 MB.');
          const fileInput = document.getElementById(`arquivos-${riscoIndex}`) as HTMLInputElement;
          if (fileInput) {
            fileInput.value = '';
          }
          this.spinnerService.hide();
          return;
        }

        if (file.type == "image/jpg" ||
          file.type == "image/jpeg" ||
          file.type == "image/png" ||
          file.type == "application/pdf" ||
          file.type == "audio/mpeg" ||
          file.type == "video/mp4"
        ) {
          formData.append(file.name, file);
        } else {
          this.toastr.warning('Só é possível subir documentos .jpg, .jpeg, .png, .pdf, .mp3 e .mp4');
          const fileInput = document.getElementById(`arquivos-${riscoIndex}`) as HTMLInputElement;
          if (fileInput) {
            fileInput.value = '';
          }
          this.spinnerService.hide();
          return;
        }
      }

      const result = await lastValueFrom(this.arquivoService.setArquivoPlanoAcaoBase64(formData))
        .catch((err) => {
          return this.ConvivaErrors.handleResultError(err);
        });

      if (!result.isSucess) {
        const mensagemErroUpload = result.message
          ? `Erro ao anexar documento: ${result.message}`
          : 'Erro ao anexar documento.';
        this.toastr.error(mensagemErroUpload);
        this.spinnerService.hide();
        return;
      }

      const riscoControl = this.riscosForm.at(riscoIndex) as FormGroup;
      const arquivosAtuais = riscoControl.get('arquivos')?.value || [];
      const novosArquivos = [...arquivosAtuais, ...result.data];
      riscoControl.patchValue({ arquivos: novosArquivos });

      this.spinnerService.hide();
      this.toastr.success('Documento(s) anexado(s) com sucesso!');
    }
  }

  public visualizarArquivo(index: number, riscoIndex: number): void {
    const arquivos = this.getArquivosRisco(riscoIndex);
    if (index >= 0 && index < arquivos.length) {
      this.arquivoVisualizando = arquivos[index];
      this.showModalVisualizarArquivo = true;
    }
  }

  public fecharModalVisualizarArquivo(): void {
    this.showModalVisualizarArquivo = false;
    this.arquivoVisualizando = undefined;
  }

  public async DownloadArquivo(index: number, riscoIndex: number) {
    const arquivos = this.getArquivosRisco(riscoIndex);
    if (index >= 0 && index < arquivos.length) {
      const arquivo = arquivos[index];

      this.spinnerService.show();
      try {
        const response = await lastValueFrom(
          this.arquivoService.getArquivoPorNome(arquivo.nome)
        );

        const url = window.URL.createObjectURL(response);
        const link = document.createElement('a');
        link.href = url;
        link.download = arquivo.nome;
        link.click();
        window.URL.revokeObjectURL(url);

        this.spinnerService.hide();
      } catch (err) {
        this.ConvivaErrors.handleResultError(err);
        this.spinnerService.hide();
      }
    }
  }

  public popupremoverarquivo(index: number, riscoIndex: number) {
    this.codigoArquivoRemover = index;
    this.riscoIndexAtual = riscoIndex;

    const arquivos = this.getArquivosRisco(riscoIndex);
    if (index >= 0 && index < arquivos.length) {
      this.arquivoRemover = arquivos[index];
    }

    this.showModalDeletarArquivo = true;
  }

  public removeFile() {
    if (this.riscoIndexAtual !== undefined && this.riscoIndexAtual >= 0) {
      const riscoControl = this.riscosForm.at(this.riscoIndexAtual) as FormGroup;
      const arquivos = riscoControl.get('arquivos')?.value || [];
      arquivos.splice(this.codigoArquivoRemover!, 1);
      riscoControl.patchValue({ arquivos });

      const fileInput = document.getElementById(`arquivos-${this.riscoIndexAtual}`) as HTMLInputElement;
      if (fileInput) {
        fileInput.value = '';
      }
    }

    this.FecharModalDeletarArquivo();
  }

  public FecharModalDeletarArquivo() {
    this.showModalDeletarArquivo = false;
    this.riscoIndexAtual = undefined;
    this.codigoArquivoRemover = null;
  }

  public gerarPDFPlano(): void {
    if (!this.planoContingencia) {
      this.toastr.error('Nenhum plano disponível para download');
      return;
    }

    this.spinnerService.show();

    try {
      const jsPDFConstructor = (window as any).jspdf?.jsPDF || (window as any).jsPDF;

      if (!jsPDFConstructor) {
        throw new Error('jsPDF não está carregado. Verifique o index.html');
      }

      const doc = new jsPDFConstructor();

      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();
      const margin = 15;
      const maxWidth = pageWidth - (margin * 2);
      let yPosition = margin;

      const checkAndAddPage = (requiredSpace: number = 20): boolean => {
        if (yPosition + requiredSpace > pageHeight - margin) {
          doc.addPage();
          yPosition = margin;
          return true;
        }
        return false;
      };

      // ========== CABEÇALHO ==========
      doc.setFillColor(26, 122, 154);
      doc.rect(0, 0, pageWidth, 35, 'F');

      doc.setTextColor(255, 255, 255);
      doc.setFontSize(18);
      doc.setFont('helvetica', 'bold');
      doc.text('Plano de Contingencia Escolar', pageWidth / 2, 15, { align: 'center' });

      doc.setFontSize(10);
      doc.setFont('helvetica', 'normal');
      const dataGeracao = new Date().toLocaleDateString('pt-BR', {
        day: '2-digit', month: '2-digit', year: 'numeric',
        hour: '2-digit', minute: '2-digit'
      });
      doc.text(`Gerado em: ${dataGeracao}`, pageWidth / 2, 25, { align: 'center' });

      yPosition = 45;
      doc.setTextColor(0, 0, 0);

      // ========== INFORMAÇÕES DO PLANO ==========
      doc.setFillColor(240, 240, 240);
      doc.rect(margin, yPosition, maxWidth, 8, 'F');
      doc.setFontSize(12);
      doc.setFont('helvetica', 'bold');
      doc.text('INFORMACOES DO PLANO', margin + 2, yPosition + 6);
      yPosition += 12;

      // Status com círculo colorido
      doc.setFontSize(10);
      doc.setFont('helvetica', 'bold');
      doc.text('Status:', margin, yPosition);

      const statusTexto = this.getStatusTextoPDF(this.planoContingencia.status ?? 0);
      const statusCor = this.getStatusColorPDF(this.planoContingencia.status ?? 0);

      doc.setFillColor(statusCor[0], statusCor[1], statusCor[2]);
      doc.circle(margin + 20, yPosition - 2, 2, 'F');

      doc.setFont('helvetica', 'normal');
      doc.text(statusTexto, margin + 25, yPosition);
      yPosition += 10;

      const infoData = [
        ['Vigencia', this.planoContingencia.vigencia?.toString() || 'N/A'],
        ['URE (Diretoria)', this.planoContingencia.nmDiretoria || 'N/A'],
        ['Escola', this.planoContingencia.nmEscola || 'N/A'],
        ['Responsavel (Diretor)', this.planoContingencia.nomeResponsavel || 'N/A'],
        ['Codigo do Plano', this.planoContingencia.cdPlano?.toString() || 'N/A'],
      ];

      doc.autoTable({
        startY: yPosition,
        head: [],
        body: infoData,
        theme: 'grid',
        styles: { fontSize: 9, cellPadding: 3 },
        columnStyles: {
          0: { fontStyle: 'bold', cellWidth: 50, fillColor: [245, 245, 245] },
          1: { cellWidth: maxWidth - 50 }
        },
        margin: { left: margin, right: margin }
      });

      yPosition = doc.lastAutoTable.finalY + 12;

      // ========== JUSTIFICATIVA DE REPROVAÇÃO (se aplicável) ==========
      if ((this.planoContingencia.status === 2 || this.planoContingencia.status === 6) && this.justificativaReprovacao) {
        checkAndAddPage(35);

        doc.setFillColor(255, 220, 220);
        doc.rect(margin, yPosition, maxWidth, 8, 'F');
        doc.setFontSize(11);
        doc.setFont('helvetica', 'bold');
        doc.setTextColor(203, 37, 37);
        doc.text('MOTIVO DA REPROVACAO / DEVOLUCAO', margin + 2, yPosition + 6);
        yPosition += 12;

        doc.setTextColor(0, 0, 0);
        doc.setFont('helvetica', 'normal');
        doc.setFontSize(9);
        const justLines = doc.splitTextToSize(this.justificativaReprovacao, maxWidth - 4);
        justLines.forEach((line: string) => {
          checkAndAddPage();
          doc.text(line, margin + 2, yPosition);
          yPosition += 5;
        });
        yPosition += 10;
      }

      // ========== COMITÊ ==========
      checkAndAddPage(35);
      doc.setFillColor(240, 240, 240);
      doc.rect(margin, yPosition, maxWidth, 8, 'F');
      doc.setFontSize(11);
      doc.setFont('helvetica', 'bold');
      doc.setTextColor(0, 0, 0);
      doc.text('COMITE', margin + 2, yPosition + 6);
      yPosition += 12;

      doc.setFont('helvetica', 'normal');
      doc.setFontSize(9);
      const comiteLines = doc.splitTextToSize(this.planoContingencia.comite || 'Nao informado', maxWidth - 4);
      comiteLines.forEach((line: string) => {
        checkAndAddPage();
        doc.text(line, margin + 2, yPosition);
        yPosition += 5;
      });
      yPosition += 10;

      // ========== RISCOS ==========
      if (this.planoContingencia.riscos && this.planoContingencia.riscos.length > 0) {
        checkAndAddPage(45);

        doc.setFillColor(26, 122, 154);
        doc.rect(margin, yPosition, maxWidth, 8, 'F');
        doc.setFontSize(12);
        doc.setFont('helvetica', 'bold');
        doc.setTextColor(255, 255, 255);
        doc.text(`RISCOS (${this.planoContingencia.riscos.length} risco(s) cadastrado(s))`, margin + 2, yPosition + 6);
        yPosition += 15;
        doc.setTextColor(0, 0, 0);

        this.planoContingencia.riscos.forEach((risco: Risco, index: number) => {
          checkAndAddPage(60);

          // Cabeçalho do risco
          doc.setFillColor(230, 230, 230);
          doc.rect(margin, yPosition, maxWidth, 7, 'F');
          doc.setFontSize(10);
          doc.setFont('helvetica', 'bold');
          doc.text(`Risco ${index + 1}`, margin + 2, yPosition + 5);
          yPosition += 10;

          // --- SEÇÃO: RISCO ---
          doc.setFillColor(245, 245, 245);
          doc.rect(margin, yPosition, maxWidth, 6, 'F');
          doc.setFontSize(9);
          doc.setFont('helvetica', 'bold');
          doc.text('Risco', margin + 2, yPosition + 4);
          yPosition += 8;

          const riscoData: string[][] = [
            ['Perigo', Array.isArray(risco.perigo) ? risco.perigo.join(', ') : (risco.perigo || 'N/A')],
            ['Vulnerabilidade', Array.isArray(risco.vulnerabilidade) ? risco.vulnerabilidade.join(', ') : (risco.vulnerabilidade || 'N/A')],
            ['Justificativa de Vulnerabilidade', risco.justificativaVulnerabilidade || 'N/A'],
            ['Dano', Array.isArray(risco.dano) ? risco.dano.join(', ') : (risco.dano || 'N/A')],
            ['Justificativa de Dano', risco.justificativaDano || 'N/A'],
            ['Grau de Risco', risco.grauRisco || 'N/A'],
            ['Justificativa de Grau de Risco', risco.justificativaGrauRisco || 'N/A'],
          ];

          doc.autoTable({
            startY: yPosition,
            head: [],
            body: riscoData,
            theme: 'striped',
            styles: { fontSize: 8, cellPadding: 2.5 },
            columnStyles: {
              0: { fontStyle: 'bold', cellWidth: 55, fillColor: [250, 250, 250] },
              1: { cellWidth: maxWidth - 55 }
            },
            margin: { left: margin, right: margin }
          });
          yPosition = doc.lastAutoTable.finalY + 8;

          // --- SEÇÃO: AÇÕES ANTES DO FATO ---
          checkAndAddPage(30);
          doc.setFillColor(245, 245, 245);
          doc.rect(margin, yPosition, maxWidth, 6, 'F');
          doc.setFontSize(9);
          doc.setFont('helvetica', 'bold');
          doc.text('Acoes antes do fato', margin + 2, yPosition + 4);
          yPosition += 8;

          const antesData: string[][] = [
            ['Prevencao', risco.prevencao || 'N/A'],
            ['Mitigacao', risco.mitigacao || 'N/A'],
            ['Preparacao', risco.preparacao || 'N/A'],
          ];

          doc.autoTable({
            startY: yPosition,
            head: [],
            body: antesData,
            theme: 'striped',
            styles: { fontSize: 8, cellPadding: 2.5 },
            columnStyles: {
              0: { fontStyle: 'bold', cellWidth: 55, fillColor: [250, 250, 250] },
              1: { cellWidth: maxWidth - 55 }
            },
            margin: { left: margin, right: margin }
          });
          yPosition = doc.lastAutoTable.finalY + 8;

          // --- SEÇÃO: AÇÕES DURANTE O FATO ---
          checkAndAddPage(30);
          doc.setFillColor(245, 245, 245);
          doc.rect(margin, yPosition, maxWidth, 6, 'F');
          doc.setFontSize(9);
          doc.setFont('helvetica', 'bold');
          doc.text('Acoes durante o fato', margin + 2, yPosition + 4);
          yPosition += 8;

          const duranteData: string[][] = [
            ['Evacuacao do Predio', risco.evacuacaoPredio || 'N/A'],
            ['Acionamento dos Orgaos', risco.acionamentoOrgaos || 'N/A'],
            ['Isolamento das Areas', risco.isolamentoAreas || 'N/A'],
            ['Comunicacao com URE', risco.comunicacaoURE || 'N/A'],
          ];

          doc.autoTable({
            startY: yPosition,
            head: [],
            body: duranteData,
            theme: 'striped',
            styles: { fontSize: 8, cellPadding: 2.5 },
            columnStyles: {
              0: { fontStyle: 'bold', cellWidth: 55, fillColor: [250, 250, 250] },
              1: { cellWidth: maxWidth - 55 }
            },
            margin: { left: margin, right: margin }
          });
          yPosition = doc.lastAutoTable.finalY + 8;

          // --- SEÇÃO: AÇÕES DEPOIS DO FATO ---
          checkAndAddPage(30);
          doc.setFillColor(245, 245, 245);
          doc.rect(margin, yPosition, maxWidth, 6, 'F');
          doc.setFontSize(9);
          doc.setFont('helvetica', 'bold');
          doc.text('Avaliacao do Fato Ocorrido', margin + 2, yPosition + 4);
          yPosition += 8;

          const depoisData: string[][] = [
            ['Avaliacao dos Danos', risco.avaliacaoDanos || 'N/A'],
            ['Limpeza e Reorganizacao', risco.limpezaReorganizacao || 'N/A'],
            ['Apoio Psicossocial', risco.apoioPsicossocial || 'N/A'],
            ['Revisao do Plano', risco.revisaoPlano || 'N/A'],
          ];

          doc.autoTable({
            startY: yPosition,
            head: [],
            body: depoisData,
            theme: 'striped',
            styles: { fontSize: 8, cellPadding: 2.5 },
            columnStyles: {
              0: { fontStyle: 'bold', cellWidth: 55, fillColor: [250, 250, 250] },
              1: { cellWidth: maxWidth - 55 }
            },
            margin: { left: margin, right: margin }
          });
          yPosition = doc.lastAutoTable.finalY + 8;

          // --- SEÇÃO: ENCAMINHAMENTOS ---
          checkAndAddPage(25);
          doc.setFillColor(245, 245, 245);
          doc.rect(margin, yPosition, maxWidth, 6, 'F');
          doc.setFontSize(9);
          doc.setFont('helvetica', 'bold');
          doc.text('Encaminhamentos', margin + 2, yPosition + 4);
          yPosition += 8;

          doc.autoTable({
            startY: yPosition,
            head: [],
            body: [['Encaminhamentos', risco.encaminhamentos || 'N/A']],
            theme: 'striped',
            styles: { fontSize: 8, cellPadding: 2.5 },
            columnStyles: {
              0: { fontStyle: 'bold', cellWidth: 55, fillColor: [250, 250, 250] },
              1: { cellWidth: maxWidth - 55 }
            },
            margin: { left: margin, right: margin }
          });
          yPosition = doc.lastAutoTable.finalY + 8;

          // --- SEÇÃO: SISTEMA DE ALERTA / COMUNICAÇÃO ---
          checkAndAddPage(30);
          doc.setFillColor(245, 245, 245);
          doc.rect(margin, yPosition, maxWidth, 6, 'F');
          doc.setFontSize(9);
          doc.setFont('helvetica', 'bold');
          doc.text('Sistema de alerta / comunicacao', margin + 2, yPosition + 4);
          yPosition += 8;

          const alertaData: string[][] = [
            ['Comunicacao Interna', risco.comunicacaoInterna || 'N/A'],
            ['Comunicacao Externa', risco.comunicacaoExterna || 'N/A'],
            ['Meios Sonoros/Visuais/Digitais', risco.meiosSonoros || 'N/A'],
          ];

          doc.autoTable({
            startY: yPosition,
            head: [],
            body: alertaData,
            theme: 'striped',
            styles: { fontSize: 8, cellPadding: 2.5 },
            columnStyles: {
              0: { fontStyle: 'bold', cellWidth: 55, fillColor: [250, 250, 250] },
              1: { cellWidth: maxWidth - 55 }
            },
            margin: { left: margin, right: margin }
          });
          yPosition = doc.lastAutoTable.finalY + 8;

          // --- ROTA DE FUGA (anexos) ---
          checkAndAddPage(20);
          doc.setFillColor(245, 245, 245);
          doc.rect(margin, yPosition, maxWidth, 6, 'F');
          doc.setFontSize(9);
          doc.setFont('helvetica', 'bold');
          doc.text('Rota de fuga (anexos)', margin + 2, yPosition + 4);
          yPosition += 8;

          const documentosTexto = risco.arquivos && risco.arquivos.length > 0
            ? `${risco.arquivos.length} documento(s) anexado(s)`
            : 'Nenhum documento anexado';

          doc.autoTable({
            startY: yPosition,
            head: [],
            body: [['Documentos', documentosTexto]],
            theme: 'striped',
            styles: { fontSize: 8, cellPadding: 2.5 },
            columnStyles: {
              0: { fontStyle: 'bold', cellWidth: 55, fillColor: [250, 250, 250] },
              1: { cellWidth: maxWidth - 55 }
            },
            margin: { left: margin, right: margin }
          });
          yPosition = doc.lastAutoTable.finalY + 12;
        });

      } else {
        checkAndAddPage(20);
        doc.setFontSize(10);
        doc.setFont('helvetica', 'italic');
        doc.setTextColor(128, 128, 128);
        doc.text('Nenhum risco cadastrado no plano.', margin, yPosition);
        yPosition += 15;
        doc.setTextColor(0, 0, 0);
      }

      // ========== DECLARAÇÃO DE CIÊNCIA ==========
      if (this.planoContingencia.cienciaResponsaveis) {
        checkAndAddPage(35);

        doc.setFillColor(240, 255, 240);
        doc.rect(margin, yPosition, maxWidth, 8, 'F');
        doc.setFontSize(11);
        doc.setFont('helvetica', 'bold');
        doc.setTextColor(31, 206, 124);
        doc.text('DECLARACAO DE CIENCIA DOS RESPONSAVEIS', margin + 2, yPosition + 6);
        yPosition += 12;

        doc.setTextColor(0, 0, 0);
        doc.setFont('helvetica', 'normal');
        doc.setFontSize(8);

        const declaracao = 'Declaro, na qualidade de Diretor(a) da Unidade Escolar, que todas as pessoas citadas como responsaveis neste plano foram devidamente informadas e estao cientes de suas atribuicoes, compromissos e responsabilidades no ambito das acoes previstas.';
        const declaracaoLines = doc.splitTextToSize(declaracao, maxWidth - 10);
        declaracaoLines.forEach((line: string) => {
          checkAndAddPage();
          doc.text(line, margin + 5, yPosition);
          yPosition += 4;
        });

        yPosition += 5;
        doc.setDrawColor(31, 206, 124);
        doc.setLineWidth(0.8);
        doc.rect(margin + 2, yPosition - 3, 4, 4);
        doc.setFillColor(31, 206, 124);
        doc.rect(margin + 2.5, yPosition - 2.5, 3, 3, 'F');
        doc.setFontSize(8);
        doc.setFont('helvetica', 'bold');
        doc.text('Confirmado', margin + 8, yPosition);
      }

      // ========== RODAPÉ EM TODAS AS PÁGINAS ==========
      const totalPages = doc.internal.getNumberOfPages();
      for (let i = 1; i <= totalPages; i++) {
        doc.setPage(i);
        doc.setFontSize(8);
        doc.setTextColor(128, 128, 128);
        doc.setFont('helvetica', 'normal');
        doc.text(`Pagina ${i} de ${totalPages}`, pageWidth / 2, pageHeight - 10, { align: 'center' });
        doc.text('Plano de Contingencia Escolar', margin, pageHeight - 10);
        doc.text(dataGeracao, pageWidth - margin, pageHeight - 10, { align: 'right' });
      }

      // ========== SALVAR ==========
      const escolaNome = this.planoContingencia.nmEscola?.replace(/[^a-zA-Z0-9]/g, '_') || 'Escola';
      const vigencia = this.planoContingencia.vigencia || 'SemAno';
      const codigoPlano = this.planoContingencia.cdPlano || '0';
      const nomeArquivo = `PC_${escolaNome}_${vigencia}_ID${codigoPlano}.pdf`;

      doc.save(nomeArquivo);
      this.toastr.success('PDF gerado e baixado com sucesso!');

    } catch (error: any) {
      console.error('Erro ao gerar PDF:', error);
      this.toastr.error(`Erro ao gerar o PDF: ${error.message || 'Erro desconhecido'}`);
    } finally {
      this.spinnerService.hide();
    }
  }

  private getStatusColorPDF(status: number): number[] {
    const statusColors: { [key: number]: number[] } = {
      0: [153, 153, 153],    // Pendente - Cinza
      1: [40, 167, 69],      // Aprovado - Verde
      2: [203, 37, 37],      // Devolvido - Vermelho
      3: [0, 110, 189],      // Novo - Azul
      4: [245, 126, 58],     // Aguardando Supervisor - Laranja
      5: [245, 126, 58],     // Aguardando PEC - Laranja
      6: [203, 37, 37],      // Devolvido - Vermelho
    };
    return statusColors[status] || [153, 153, 153];
  }

  private getStatusTextoPDF(status: number): string {
    const statusMap: { [key: number]: string } = {
      0: 'Pendente',
      1: 'Aprovado',
      2: 'Devolvido para ajustes',
      3: 'Novo',
      4: 'Aguardando Validacao Supervisor de Ensino',
      5: 'Aguardando Validacao PEC CONVIVA',
      6: 'Devolvido para ajustes',
    };
    return statusMap[status] || 'Sem status';
  }
}
